<template>
  <div class="station-alert" v-if="active">
    <div class="row m-2">
      <div class="col-3 station-alert-animation">
        <StationSuccessAnimation v-if="isTypeSuccess" />
        <StationErrorAnimation v-if="isTypeError" />
        <StationInformationAnimation v-if="isTypeInformation" />
      </div>
      <div class="col-9">
        <h1>{{title}}</h1>
        <h2 class="station-alert-message" v-html="message" />
      </div>
    </div>
  </div>
</template>

<style>
/* Note: Style not scoped so the message can have dynamic HTML */
.station-alert {
  margin-bottom: 0.5rem;
}
.station-alert h1 {
  font-size: 2.5rem;
  line-height: 2.5rem;
  font-weight: bold;
  margin: 0 0 4px 0;
}
@media (min-width: 1900px) {
  .station-alert-animation {
    flex: 0 0 150px !important;
    max-width: 150px !important;
  }
}
.station-alert-message {
  margin: 0 0 4px 0;
}
.station-alert-message > strong {
  color: #4da9ff;
}
</style>


<script>
import StationSuccessAnimation from '@/apps/glass-production-station/src/components/animations/stationSuccessAnimation'
import StationErrorAnimation from '@/apps/glass-production-station/src/components/animations/stationErrorAnimation'
import StationInformationAnimation from '@/apps/glass-production-station/src/components/animations/stationInformationAnimation'

export default {
  name: 'StationAlertMessage',
  components: {
    StationSuccessAnimation,
    StationErrorAnimation,
    StationInformationAnimation
  },
  data() {
    return {
      active: false,
      type: '',
      title: '',
      message: ''     // Note: Supports HTML
    }
  },
  computed: {
    isTypeSuccess() {
      return this.type == 'success'
    },
    isTypeError() {
      return this.type == 'error'
    },
    isTypeInformation() {
      return this.type == 'info'
    }
  },
  methods: {
    displayAlert(type, title, messageHTML) {
      this.active = false

      // Run in next tick to reset animations
      this.$nextTick(() => {
        this.active = true
        this.type = type
        this.title = title
        this.message = messageHTML
      })
    },
    hide() {
      this.active = false
    }
  }  
}
</script>